import { useEffect, useState } from "react"
import { GroupHeader, groupSelector, handleMultiple, mainHeader, multipleAnswerForm, selectHeader, singleAnswerForm } from "./functions"

const preFinishOpt = [
  "ESTUCAMENTO",
  "CHAPISCO",
  "Emboço + Reboco",
  "Reboco em Massa Única",
  "GESSO CORRIDO",
  "Nenhum",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
];

const finishOpt = [
  "GESSO ST",
  "GESSO RU",
  "GESSO RF",
  "GESSO LEVE",
  "GESSO REMOVIVEL",
  "GESSO CORRIDO",
  "GESSO MINERAL",
  "ARGAMASSADO",
  "PINTURA",
  "Textura Branca + Pintura",
  "Textura Pigmentada",
  "PLACA CIMENTICIA",
  "ACUSTICO",
  "PVC",
  "MADEIRA",
  "Nenhum",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
];


const CeilingQuestions = ({ onGroupsChange, formData, preGroup, finished }) => {
  const [groups, setGroups] = useState([])
  const [currentGroup, setCurrentGroup] = useState([])
  const [formatPav, setFormatPav] = useState([])
  const [toggle, setToggle] = useState(true)
  const { ceiling } = formData.roomDefinitions
  const { pavements } = formData
  const [visibleGroups, setVisibleGroups] = useState([])

  const handleGroup = (e) => {
    if (finished) return;
    if (!currentGroup.includes(e)) {
      setCurrentGroup([...currentGroup, e])
    } else {
      setCurrentGroup(currentGroup.filter(i => i !== e))
    }
  }

  const finishGroup = () => {
    setGroups([...groups, { rooms: currentGroup.sort(), preFinish: [], finish: "" }])
    setCurrentGroup([])
  }

  useEffect(() => {
    onGroupsChange(groups)
  }, [groups])

  useEffect(() => {
    if (groups.length > 0) {
      const elem = document.getElementById(`teto-${groups.length - 1}`);
      if (elem) {
        elem.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [groups.length])

  const checkRemaining = (arr) => {
    const remaining = arr?.filter(i => !groups.flatMap(group => group.rooms).includes(i));
    return remaining;
  }

  const selectAll = () => {
    if (currentGroup.join('') === checkRemaining(ceiling).join('')) {
      setCurrentGroup([])
    } else {
      setCurrentGroup(checkRemaining(ceiling))
    }
  }

  const selectBulk = (priv) => {
    const privAreas = formData.roomDefinitions.privAreas.filter(i => ceiling.includes(i));
    if (priv) {
      setCurrentGroup(privAreas);
    } else {
      const common = ceiling.filter(i => !privAreas.includes(i))
      setCurrentGroup(common)
    }
  }

  useEffect(() => {
    const pavs = pavements.map(i => {
      return {
        pavement: i.pavement,
        rooms: i.rooms.filter(j => ceiling.includes(j))
      }
    })
    setFormatPav(pavs.filter(i => i.rooms.length > 0));
    setGroups(preGroup || [])
  }, [])

  const handleChanges = (e, idx, field) => {
    if (finished) return;
    const newGroups = [...groups];
    newGroups[idx][field] = e;
    setGroups(newGroups);
  }

  const resetGroup = (idx) => {
    const newGroups = [...groups];
    newGroups.splice(idx, 1);
    setGroups(newGroups);
    setCurrentGroup([]);
  }

  const resetAll = () => {
    setGroups([])
  }

  const handleMultipleChanges = (idx, field, type) => {
    handleMultiple(finished, groups, idx, field, type, { type }, setGroups);
  }

  const handleToggle = (idx) => {
    if (visibleGroups.includes(idx)) {
      setVisibleGroups(visibleGroups.filter(i => i !== idx))
    } else {
      setVisibleGroups([...visibleGroups, idx])
    }
  }

  return <div className="form-section">
    {mainHeader("Teto", groups, resetAll, toggle, setToggle)}

    {toggle && <>

      {groups.length > 0 && <>

        {groups.map((i, idx) => {

          return <div id={`teto-${idx}`} key={idx}>

            <GroupHeader idx={idx} rooms={i.rooms} handleToggle={handleToggle} active={visibleGroups.includes(idx)} groups={groups} setGroups={setGroups} setCurrentGroup={setCurrentGroup} />
            {visibleGroups.includes(idx) && <div className="group-questions-container">

              {multipleAnswerForm("Quais opções de pré-acabamentos serão utilizados no teto dos ambientes desse grupo?", preFinishOpt, idx, "preFinish", groups[idx], handleMultipleChanges, formData.projRoomFull, "Pré-Acabamento de Teto", handleChanges, finished)}
              {singleAnswerForm("Qual tipo de acabamento nesses ambientes?", finishOpt, idx, "finish", formData.projRoomFull, "Tipo de Acabamento de Teto", groups[idx], handleChanges, finished)}
            </div>}
          </div>

        })}

      </>}

      {checkRemaining(ceiling).length > 0 && <>
        <label className="margin-tier-2 select-groups-header">Selecionar grupos</label>
        {selectHeader(selectAll, selectBulk)}
      </>}
      {groupSelector(formatPav, groups, currentGroup, handleGroup, finishGroup, ceiling)}
    </>}
  </div>
}

export default CeilingQuestions;